import api from '@/api';

const actions = {
  fetchPlayers: ({ getters: { accessToken } }, params) => {
    return api.players
      .getPlayers(accessToken, { params })
      .then(({ data }) => data);
  },
  //   fetchOrgs: ({ getters: { accessToken } }, params) => {
  //     return api.players
  //       .getOrganisationsForInvite(accessToken, { params })
  //       .then(({ data }) => data);
  //   },
  // };

  fetchOrgs(
    {
      getters: { accessToken },
    },
    { organisationId } = {}
  ) {
    return api.players
      .getOrganisationsForInvite(accessToken, organisationId)
      .then(res => {
        return res.data;
      });
  },
};
export default {
  actions,
};
